/* tslint:disable */
/* eslint-disable */
/* @relayHash b0d34125debbc51c6b1fa8feaaea99c9 */

import { ConcreteRequest } from "relay-runtime";
export type initSalesforceChatQueryVariables = {
    isSeller: boolean;
};
export type initSalesforceChatQueryResponse = {
    readonly viewer: {
        readonly contact1stdibsConfig: {
            readonly chatConfig: {
                readonly salesForceHost: string | null;
                readonly salesForcePartnersHost: string | null;
                readonly chatButtonId: string | null;
                readonly chatDeploymentId: string | null;
                readonly chatBaseLiveAgentContentUrl: string | null;
                readonly chatLiveAgentUrl: string | null;
                readonly salesForceOrgId: string | null;
                readonly liveAgentDevName: string | null;
            } | null;
        } | null;
    };
};
export type initSalesforceChatQuery = {
    readonly response: initSalesforceChatQueryResponse;
    readonly variables: initSalesforceChatQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSeller"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isSeller",
      "variableName": "isSeller"
    }
  ],
  "concreteType": "Contact1stdibsConfig",
  "kind": "LinkedField",
  "name": "contact1stdibsConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact1stdibsConfigInitParams",
      "kind": "LinkedField",
      "name": "chatConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salesForceHost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salesForcePartnersHost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatButtonId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatDeploymentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatBaseLiveAgentContentUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatLiveAgentUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salesForceOrgId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "liveAgentDevName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "initSalesforceChatQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "initSalesforceChatQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/326.0.0-2021-08-03T13:35:11.447Z/initSalesforceChatQuery",
    "metadata": {},
    "name": "initSalesforceChatQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '7ed41a734aa1a525f227f249d11a5f34';
export default node;
